var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-search" },
    [
      _c(
        "base-button",
        {
          staticClass: "button--icon header-search__button",
          on: {
            click: function($event) {
              _vm.showSearchForm = !_vm.showSearchForm
            }
          }
        },
        [
          _c("icon", { staticClass: "button__icon", attrs: { name: "search" } })
        ],
        1
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showSearchForm
          ? _c(
              "div",
              { staticClass: "header-search__content" },
              [
                _c("h2", { staticClass: "header-search__heading" }, [
                  _vm._v("What are you looking for?")
                ]),
                _c("navbar-search", {
                  ref: "searchBox",
                  on: {
                    "open-results": function($event) {
                      return _vm.showSubnav("search")
                    },
                    "close-results": _vm.hideSearch
                  },
                  model: {
                    value: _vm.searchParam,
                    callback: function($$v) {
                      _vm.searchParam = $$v
                    },
                    expression: "searchParam"
                  }
                }),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.subnav && _vm.subnav === "search"
                    ? _c(
                        "div",
                        {
                          staticClass: "header-search__results",
                          on: {
                            mouseenter: function($event) {
                              _vm.overSearchResults = true
                            },
                            mouseleave: function($event) {
                              _vm.overSearchResults = false
                            }
                          }
                        },
                        [
                          _c("navbar-search-results", {
                            ref: "searchResults",
                            attrs: {
                              "collection-handle": _vm.allProductsHandle,
                              search: _vm.searchParam,
                              suggestions: _vm.suggestedSearches,
                              productImageBackgroundColor:
                                _vm.productImageBackgroundColor
                            },
                            on: {
                              selected: _vm.suggestionSelected,
                              "close-results": _vm.hideSearch
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }